/* ============================================================
   L-U-N-E-X theme — Designed by Paul Rotimi, Shopify Expert
   Licensed theme — removal of credits violates the license.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var money = function (cents) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.SM && window.SM.currency) || 'USD' });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Promo bar dismiss ---------- */
  $$('[data-promo-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var bar = btn.closest('[data-promo-bar]');
      if (bar) bar.style.display = 'none';
      try { sessionStorage.setItem('sm_promo_dismissed', '1'); } catch (e) {}
    });
  });
  try {
    if (sessionStorage.getItem('sm_promo_dismissed') === '1') {
      var bar = $('[data-promo-bar]');
      if (bar) bar.style.display = 'none';
    }
  } catch (e) {}

  /* ---------- Category dropdown (desktop) ---------- */
  $$('[data-catdrop]').forEach(function (drop) {
    var btn = $('[data-catdrop-btn]', drop);
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var wasOpen = drop.classList.contains('open');
      $$('[data-catdrop].open').forEach(function (d) { d.classList.remove('open'); });
      if (!wasOpen) drop.classList.add('open');
    });
  });
  document.addEventListener('click', function () {
    $$('[data-catdrop].open').forEach(function (d) { d.classList.remove('open'); });
  });

  /* ---------- Mobile drawer ---------- */
  var drawer = $('[data-drawer]');
  var scrim = $('[data-scrim]');
  function openDrawer() { if (drawer) drawer.classList.add('open'); if (scrim) scrim.classList.add('show'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (drawer) drawer.classList.remove('open'); if (scrim) scrim.classList.remove('show'); document.body.style.overflow = ''; }
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (scrim) scrim.addEventListener('click', function () { closeDrawer(); closeCart(); });

  /* ---------- Search tabs ---------- */
  $$('[data-search-tabs]').forEach(function (wrap) {
    var tabs = $$('[data-search-tab]', wrap);
    var form = wrap.closest('form') || wrap.parentElement.querySelector('form');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        var input = form ? form.querySelector('input[name="q"]') : null;
        if (input && tab.dataset.placeholder) input.placeholder = tab.dataset.placeholder;
      });
    });
  });

  /* ---------- Promo carousel ---------- */
  $$('[data-promo]').forEach(function (promo) {
    var slides = $$('[data-promo-slide]', promo);
    var dotsWrap = $('[data-promo-dots]', promo);
    if (slides.length < 2) return;
    var idx = 0, timer = null;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      if (dotsWrap) $$('[data-promo-dot]', dotsWrap).forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'sm-promo__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('data-promo-dot', '');
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.addEventListener('click', function () { go(i); restart(); });
        dotsWrap.appendChild(d);
      });
    }
    function restart() { if (timer) clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, 5000); }
    restart();
  });

  /* ---------- Campaign panel carousels ---------- */
  $$('[data-cpanel]').forEach(function (panel) {
    var track = $('[data-cpanel-track]', panel);
    if (!track) return;
    $$('[data-cpanel-prev]', panel).forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    });
    $$('[data-cpanel-next]', panel).forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    });
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach(function (gal) {
    var main = $('[data-gallery-main] img', gal);
    $$('[data-gallery-thumb]', gal).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-gallery-thumb]', gal).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (main && btn.dataset.full) {
          main.src = btn.dataset.full;
          if (btn.dataset.alt) main.alt = btn.dataset.alt;
        }
      });
    });
  });

  /* ---------- Variant pills -> hidden variant select ---------- */
  $$('[data-variant-pills]').forEach(function (wrap) {
    var form = wrap.closest('form');
    var select = form ? form.querySelector('select[name="id"]') : null;
    if (!select) return;
    var jsonEl = document.querySelector('[data-product-json]');
    var data = null;
    try { data = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { data = null; }

    function selectedOptions() {
      return $$('[data-option-index]', wrap).map(function (g) {
        var r = g.querySelector('input[type="radio"]:checked');
        return r ? r.value : null;
      });
    }
    function findVariant() {
      if (!data || !data.variants) return null;
      var opts = selectedOptions();
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v['option' + (j + 1)] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function applyVariant(v) {
      if (!v) return;
      select.value = v.id;
      var priceEl = $('[data-product-price]');
      if (priceEl) {
        priceEl.innerHTML = money(v.price) + (v.compare_at_price && v.compare_at_price > v.price
          ? '<span class="sm-product__compare">' + money(v.compare_at_price) + '</span>' : '');
      }
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.disabled = !v.available;
    }
    $$('input[type="radio"]', wrap).forEach(function (radio) {
      radio.addEventListener('change', function () { applyVariant(findVariant()); });
    });
    /* keep pills in sync if select changes another way */
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var priceEl = $('[data-product-price]');
      if (priceEl && opt && opt.dataset.price) {
        var p = parseInt(opt.dataset.price, 10);
        var c = opt.dataset.compare ? parseInt(opt.dataset.compare, 10) : 0;
        priceEl.innerHTML = money(p) + (c > p ? '<span class="sm-product__compare">' + money(c) + '</span>' : '');
      }
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.disabled = !!(opt && opt.disabled);
    });
  });

  /* ---------- Quantity steppers ---------- */
  $$('[data-cart-qty-minus],[data-cart-qty-plus]').forEach(function (b) {
    b.addEventListener('click', function () {
      var wrap = b.closest('.sm-qty');
      var input = wrap ? wrap.querySelector('input[name="quantity"]') : null;
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v += b.hasAttribute('data-cart-qty-plus') ? 1 : -1;
      input.value = Math.max(1, v);
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = $('[data-cartdrawer]');
  function openCart() { if (cartDrawer) cartDrawer.classList.add('open'); if (scrim) scrim.classList.add('show'); }
  function closeCart() { if (cartDrawer) cartDrawer.classList.remove('open'); if (scrim && !drawer?.classList.contains('open')) scrim.classList.remove('show'); }
  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(openCart); });
  });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeDrawer(); } });

  function cartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function lineItemHTML(item) {
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') + '" alt="" loading="lazy">' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="sm-lineitem__variant">' + item.variant_title + '</p>' : '';
    return '<div class="sm-lineitem" data-key="' + item.key + '">' +
      img +
      '<div class="sm-lineitem__info">' +
        '<p class="sm-lineitem__title">' + item.product_title + '</p>' + variant +
        '<span class="sm-lineitem__qty">' +
          '<button type="button" data-qty="-1" aria-label="Decrease">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty="1" aria-label="Increase">+</button>' +
        '</span>' +
      '</div>' +
      '<div class="sm-lineitem__right">' +
        '<span class="sm-lineitem__price">' + money(item.final_line_price) + '</span>' +
        '<button type="button" class="sm-cart-remove" data-remove>Remove</button>' +
      '</div>' +
    '</div>';
  }

  function renderCart(cart) {
    cartCount(cart.item_count);
    var itemsWrap = $('[data-cartdrawer-items]');
    var foot = $('[data-cartdrawer-foot]');
    if (!itemsWrap) return;
    if (!cart.items.length) {
      itemsWrap.innerHTML = '<div class="sm-cartdrawer__empty"><p>Your cart is empty.</p></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    itemsWrap.innerHTML = cart.items.map(lineItemHTML).join('');
    if (foot) {
      foot.style.display = '';
      var sub = $('[data-cartdrawer-subtotal]');
      if (sub) sub.textContent = money(cart.total_price);
    }
    $$('[data-qty]', itemsWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('[data-key]');
        var qtyEl = row.querySelector('.sm-lineitem__qty span');
        var q = parseInt(qtyEl.textContent, 10) + parseInt(b.dataset.qty, 10);
        changeQty(row.dataset.key, Math.max(0, q));
      });
    });
    $$('[data-remove]', itemsWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        changeQty(b.closest('[data-key]').dataset.key, 0);
      });
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return { item_count: 0, items: [] }; });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* add to cart forms */
  $$('[data-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-add-to-cart]', form);
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } });
    });
  });

  /* buy now */
  $$('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      var idInput = form.querySelector('[name="id"]');
      var id = idInput ? idInput.value : null;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? qtyInput.value : 1;
      if (!id) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: parseInt(qty, 10) || 1 })
      }).then(function () { window.location.href = '/checkout'; })
        .catch(function () { btn.disabled = false; });
    });
  });

  /* ---------- Sort select ---------- */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });

  /* ---------- Mobile filter toggle ---------- */
  $$('[data-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var f = document.getElementById(btn.getAttribute('aria-controls'));
      if (f) f.classList.toggle('open');
    });
  });

  /* price filter apply */
  $$('[data-price-apply]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-price-filter]');
      var min = wrap.querySelector('[data-price-min]').value;
      var max = wrap.querySelector('[data-price-max]').value;
      var url = new URL(btn.dataset.base || window.location.href);
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      if (min) url.searchParams.set('filter.v.price.gte', min);
      if (max) url.searchParams.set('filter.v.price.lte', max);
      window.location.href = url.toString();
    });
  });

  /* initial cart count */
  refreshCart();

  /* ---------- Image search (snap to search) ---------- */
  $$('.sm-search__iconbtn').forEach(function (btn) {
    if (btn.getAttribute('data-sm-imgbound')) return;
    btn.setAttribute('data-sm-imgbound', '1');
    btn.addEventListener('click', function () {
      var picker = document.createElement('input');
      picker.type = 'file';
      picker.accept = 'image/*';
      picker.setAttribute('aria-hidden', 'true');
      picker.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;opacity:0;pointer-events:none;';
      picker.addEventListener('change', function () {
        var file = picker.files && picker.files[0];
        if (picker.parentNode) picker.parentNode.removeChild(picker);
        if (file) smImageSearchPreview(file);
      });
      document.body.appendChild(picker);
      picker.click();
    });
  });

  function smImageSearchPreview(file) {
    var old = document.getElementById('sm-imgsearch');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var src = (window.URL || window.webkitURL).createObjectURL(file);
    var ov = document.createElement('div');
    ov.id = 'sm-imgsearch';
    ov.className = 'sm-imgsearch';
    ov.innerHTML =
      '<div class="sm-imgsearch__box" role="dialog" aria-modal="true" aria-labelledby="sm-imgsearch-title">' +
      '<button type="button" class="sm-imgsearch__close" aria-label="Close image search">&times;</button>' +
      '<h2 class="sm-imgsearch__title" id="sm-imgsearch-title">Image search</h2>' +
      '<img class="sm-imgsearch__preview" alt="Your photo">' +
      '<p class="sm-imgsearch__hint">Here is your photo. Describe the product below and we will find it for you.</p>' +
      '<form class="sm-imgsearch__form" action="/search" method="get">' +
      '<input class="sm-imgsearch__input" type="search" name="q" placeholder="Describe the product, e.g. wireless earbuds" aria-label="Describe the product">' +
      '<button class="sm-imgsearch__go" type="submit">Search</button>' +
      '</form>' +
      '<button type="button" class="sm-imgsearch__retake">Use a different photo</button>' +
      '</div>';
    ov.querySelector('.sm-imgsearch__preview').src = src;
    document.body.appendChild(ov);
    document.body.classList.add('sm-imgsearch-open');
    function close() {
      if (ov.parentNode) ov.parentNode.removeChild(ov);
      document.body.classList.remove('sm-imgsearch-open');
      try { (window.URL || window.webkitURL).revokeObjectURL(src); } catch (e) {}
    }
    ov.querySelector('.sm-imgsearch__close').addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    ov.querySelector('.sm-imgsearch__retake').addEventListener('click', function () {
      close();
      var again = document.querySelector('.sm-search__iconbtn');
      if (again) again.click();
    });
    var field = ov.querySelector('.sm-imgsearch__input');
    if (field) field.focus();
  }
})();
